/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />

namespace TabAurous.Production {

    import fld = ReceiptMaterialItemsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class ReceiptMaterialItemsEditor extends _Ext.GridEditorBase<ReceiptMaterialItemsRow> {



        protected getColumnsKey() { return "Production.ReceiptMaterialItems"; }
        protected getDialogType() { return ReceiptMaterialItemsDialog; }
        protected getLocalTextPrefix() { return ReceiptMaterialItemsRow.localTextPrefix; }
        protected form: ReceiptMaterialItemsForm;

        private pendingChanges: Q.Dictionary<any> = {};

        // #region Variables  
        public PartyId: number;
        public DeptId: number;
        public LineNo: number;
        public BagNo: string;
        public karatid: number;
        public producttypeid: number;
        public metalcolorid: number;

        // #endregion


        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            //   this.slickGrid.setOptions({ forceFitColumns: true, showFooterRow: true });
            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as ReceiptMaterialDetailsDialog).CalculateTotals();
                }
            });
            this.slickGrid.onRender.subscribe(() => {
                // call of the function that will bind the editors with the fields (<input>) of the html page
                this.SetInlineLookupEditor();
            });
        }

        private Master;
        //public setEditValue(source: DismantlingRow, property) {
        //    super.setOwnerEntity(source);
        //    this.Master = source;
        //    super.setEditValue(source, property);
        //}
        // #region Column Add -Remove
        protected createSlickGrid(): Slick.Grid {
            var grid = super.createSlickGrid();
            grid.setSelectionModel(new Slick.RowSelectionModel());
            return grid;
        }
        protected getColumns() {

            var columns = super.getColumns();

            var int = ctx => ColumnFormatter.integerInputFormatter(ctx, this);
            var wt = ctx => ColumnFormatter.WeightFormatter(ctx, this);

            Q.first(columns, x => x.field === fld.Pieces).format = int;
            Q.first(columns, x => x.field === fld.Weight).format = wt;
            //let ParentMetalColumn = Q.first(columns, x => x.field == fld.ToProductId);
            //ParentMetalColumn.format = ctx => {
            //    if (ctx.item.ItemTypeId == "104") {
            //        this.metalcolorid = parseInt(ctx.item.MetalColorId);
            //        this.karatid = parseInt(ctx.item.KaratId);
            //        this.producttypeid = parseInt(ctx.item.ProductTypeId);
            //        return this.selectFormatter(ctx, fld.ToProductId, Q.getLookup("AllProducts"), this);
            //    }
            //}
            var ParentMetalColumn = Q.first(columns, x => x.field === fld.ToProductId);
            ParentMetalColumn.referencedFields = [fld.ToProductId];
            ParentMetalColumn.format = ctx => {

                if (ctx.item.ItemTypeId == "104") {
                    var width = (ctx.column.width) as number - 10;
                    return '<input type="hidden" style="text-align: right; width:' + width + 'px;" id="ToProductId' + ctx.row + '" title="Parent Metal" />';
                }
            };

            //Q.first(columns, x => x.field === fld.StoneStatusId).format = ctx => {
            //    var EnumFormatter = new Serenity.EnumFormatter();
            //    EnumFormatter.enumKey = "Fixed.StoneStatus";

            //    var EnumSelectFormatter = new Common.EnumSelectFormatter();
            //    EnumSelectFormatter.enumKey = "Fixed.StoneStatus";
            //    var width = (ctx.column.width) as number - 10;
            //    return this.selectFormatter(ctx, fld.StoneStatusId, Q.getLookup("AllProducts"), this);
            //}

            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            return columns;
        }

        // #endregion


        //#region  ItemGrid Inline Editor

        // **** Onclick Event ****
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);


            if (e.isDefaultPrevented())
                return;
            this.slickGrid.setSelectedRows([row]);

            var item = this.itemAt(row);
            //To Set Master Product Image
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    //if ( == 0) {
                    //    Q.alert("Voucher is ReadOnly can not Delete!!")
                    //}
                    //else {
                    //TODO: Validate for TransItemID in RefTransItemID in Stock
                    Q.confirm('Are you sure want to Delete? ', () => {

                        var id = this.id(item);/*
                            var refid = Stock.StockItemRow.getLookup().items.filter(x => x.RefTransItemId == item.TransItemId && x.RefVoucherId == item.VoucherTypeId && x.RefTransId == item.TransId)[0];
                            if (refid != null) {
                                if (refid.PartyId != null || refid.PartyId > 0) {
                                    Q.alert("This Item has been used in transactions Cannot Delete!");
                                    return;
                                }
                            } else {

                              //  this.TotalItems = this.view.getItems().length - 1;
                            */    this.view.deleteItem(id);
                    }
                    );

                    this.view.refresh();
                }

                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }


        }

        //Row Edit Event handler
        private inputsChange(e: JQueryEventObject,) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;

            // *** Validate Decimal & Integer***
            if (field === fld.Weight) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            } else if (field === fld.Pieces) {
                value = Q.parseInteger(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else if (input.hasClass('numeric')) {
                var i = Q.parseInteger(text);
                if (isNaN(i) || i > 32767 || i < 0) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = i;
            }
            else {
                value = text;
            }

            var olddata: WIPTransactionRow[];
            WIPTransactionReceiptMaterialService.List({ ProductId: item.ProductId, AttributeId: item.AttributeId, BagNo: item.BagNo, DepartmentId: item.DepartmentId }, response =>
                olddata = response.Entities,
                { async: false });
            // **** Allow to Set Pcs to Zero for RM ****
            if (field === fld.Pieces && item.ItemTypeId != 101) {
                if (item.ItemTypeId != 104) {

                    if (olddata[0].Pieces >= value) {
                        item[field] = value;
                        item.Weight = olddata[0].Weight / olddata[0].Pieces;

                    }
                }

            }

            // **** Allow to Set Weight for RM ****
            if (field === fld.Weight && item.ItemTypeId != 101) {
                if (item.ItemTypeId != 104) {
                    if (olddata[0].Pieces == item.Pieces) {
                        q.alert('', 'Please change Pieces First', true, 2999);
                        item[field] = olddata[0].Weight;
                        return;
                    }
                }
                if (olddata[0].Weight >= value) {
                    item[field] = value;
                    item.NetWeight = value;
                    if (item.ItemTypeId == 104)
                        item.PureWeight = value * item.Purity;
                }

            }
            // *** Set Department ***
            if (field === fld.ToProductId && value > 0) {
                item[field] = value;
            }



            this.view.updateItem(id, item);
            this.view.refresh();
            (this.parentDialog as IssueMaterialDetailsDialog).CalculateTotals();

            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }


        // **** for Dropdown in Gird ****
        selectFormatter(ctx: Slick.FormatterContext, idField: string, lookup: Q.Lookup<any>, editor: any) {
            var klass = 'edit';
            var item = ctx.item
            var id = editor.id(item);
            var pending = editor.pendingChanges[id]
            var column = ctx.column as Slick.Column;
            let newitems;
            OMS.RawMaterialMasterService.GetParentList({
                MetalColorId: this.metalcolorid, KaratId: this.karatid, ProductTypeId: this.producttypeid
            }, response => { newitems = response.Entities }, { async: false });

            lookup.items = newitems;//lookup.items.filter(x => x.ProductTypeId == this.producttypeid && x.KaratId == this.karatid && x.MetalColorId == this.metalcolorid);
            if (pending && pending[idField] !== undefined) {
                klass += ' dirty';
            }

            var value = this.getEffectiveValues(item, idField, editor);
            var markup = "<select class='" + klass +
                "' data-field='" + idField +
                "' style='width: 100%; max-width: 100%'>";
            for (var c of lookup.items) {
                let id = c[lookup.idField];
                markup += "<option value='" + Q.attrEncode(id) + "'"
                if (id == value) {
                    markup += " selected";
                }
                markup += ">" + Q.htmlEncode(c[lookup.textField]) + "</option>";
            }
            return markup + "</select>";
        }

         
        getEffectiveValues(item, field: any, editor: any): any {
            var id = editor.id(item);
            var pending = editor.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }
        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }



        public SetInlineLookupEditor() {
            // course of all the lines present in the grid
            var Items = this.view.getItems();
            if (Items.length > 0)
                for (let Item in Items) {
                    this.InlineLookup(Item, Items);
                }
        }

        private InlineLookup(RowIndex: string, Items: IssueMaterialItemsRow[]) {

            var select = $("#ToProductId" + RowIndex);

            if (!select.hasClass("select2-offscreen")) {
                //let opt: Serenity.LookupEditorOptions = {
                //    lookupKey: IssueMaterialItemsRow.lookupKey
                //};
                let newitems: IssueMaterialItemsRow[];
                var value = Items[parseInt(RowIndex)];
                OMS.RawMaterialMasterService.GetParentList({
                    MetalColorId: value.MetalColorId, KaratId: value.KaratId, ProductTypeId: value.ProductTypeId
                }, response => { newitems = response.Entities }, { async: false });

                var parentitems = [];

                for (var i = 0; i < newitems.length; i++) {
                    var item: Select2Item = { id: newitems[i].ProductId.toString(), text: newitems[i].ProductCode, source: newitems[i] }
                    parentitems.push(item);

                }
                var Editor = new _Ext.EmptyLookupEditor($("#ToProductId" + RowIndex));
                Editor.setSelect2Items(parentitems);
                if (this.isReadOnly == true) {
                    q.showAndDisableField(Editor);
                }
                Editor.value = Q.toId(Items[RowIndex].ProductId);
                Editor.changeSelect2(e => {
                    if (Editor.value != "") {
                        Items[RowIndex].ToProductId = Q.toId(Editor.value);
                        Items[RowIndex].ToAttributeId = Editor.items.filter(x => x.id == Editor.value)[0].source.AttributeId;
                    }
                });
            }
            else {
                if (this.isReadOnly == false) {
                    select.closest('.slick-cell').find('.select2-container-disabled').removeClass('select2-container-disabled');
                    select.removeClass('readonly');
                }
            }
        }

        // #region Buttons Add-Remove
        protected getButtons() {
            let buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != "add-button");
            buttons.push({
                title: "Select Materials",
                cssClass: "order-button",
                hotkey: "alt+p",
                hint: 'alt+p',
                onClick: () => {
                    this.BagNo = (this.parentDialog as ReceiptMaterialDetailsDialog).form.BagNo.value;
                    if (this.BagNo == null || this.BagNo == "") {
                        q.alert('', 'Select Work Order to Proceed', true, 2999);
                        return;
                    }
                    var grid = Common.WIPReceiptMaterialSelectGrid;
                    var filters: _Ext.SelectGridFilters = {
                        BagNo: this.BagNo,
                        FilterItems: ItemSelection.MS,
                        DepartmentId: this.DeptId
                    }
                    var pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: grid, multiple: true, title: "Select Items",
                        preSelectedKeys: this.value.map(k => k.ProductId), GridFilters: filters, Width: 800, height: 500
                    });
                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        var self = this;
                        var details = [];

                        // #region Items to Grid
                        //for (let value of selectedItems2)
                        selectedItems2.forEach(function (value: WIPTransactionRow) {
                            let newitems;
                            this.metalcolorid = value.MetalColorId;
                            this.karatid = value.KaratId;
                            this.producttypeid = value.ProductTypeId;
                            //this.LineNo = self.LineNo;
                            OMS.RawMaterialMasterService.GetParentList({
                                MetalColorId: value.MetalColorId, KaratId: value.KaratId, ProductTypeId: value.ProductTypeId
                            }, response => { newitems = response.Entities }, { async: false });
                            var item: ReceiptMaterialItemsRow = {
                                ProductId: value.ProductId,
                                DepartmentId: self.DeptId,
                                ProductCode: value.ProductCode,
                                ItemTypeId: value.ItemTypeId,
                                AttributeId: value.AttributeId,
                                OldLineNo: value.Line_No,
                                Line_No: self.LineNo,
                                SKU: value.SKU,
                                HSN: value.HSN,
                                CertificateNo: value.CertificateNo,
                                BagNo: self.BagNo,
                                OldBagNo: value.BagNo,
                                LotNo: value.LotNo,
                                CalcOnId: value.CalcOnId,
                                Pieces: value.Pieces,
                                Weight: value.Weight,
                                NetWeight: 0,
                                RefTransId: value.TransId,
                                Purity: value.Purity,
                                PureWeight: value.PureWeight,
                                RefTransItemId: value.RefTransItemId == null ? 0 : value.RefTransItemId,
                                RefVoucherId: value.VoucherTypeId == null ? 0 : value.VoucherTypeId,
                                Attribute: value.Attribute,
                                KaratId: value.KaratId,
                                MetalColorId: value.MetalColorId,
                                ProductTypeId: value.ProductTypeId,
                                ToProductId: 0
                            };

                            details.push(item);

                        });

                        //if (this.view.getItems().length > 0) {
                        //    self.TotalItems = details.length + this.view.getItems().length;
                        //}
                        //else {
                        //    self.TotalItems = details.length;
                        //}
                        for (let Detail of details) {
                            Detail[this.getIdProperty()] = "`" + this.nextId++;
                            this.view.addItem(Detail);
                        }

                        // #endregion


                    }


                    pickerDialog.dialogOpen();
                }
            });

            return buttons;
        }
        // #endregion
    }
}